<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_payHistory" src="@/assets/images/icon_payHistory.png" alt=""/>付款记录查询</span>
      <el-main class="con">
        <el-form style="margin-left: 10px" :disabled="loading">
          <el-form-item v-if="currentUser.userType === 1">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">客户姓名：</span>
            <el-select size="small"
                       v-model="selectedCustomer"
                       placeholder="请选择"
                       filterable
                       :filter-method="dataFilter"
                       ref="select"
                       :clearable="showClose"
                       @blur.native.capture="onblur"
                       @hook:mounted="cancelReadOnly"
                       @visible-change="cancelReadOnly">
              <el-option
                v-for="item in customerOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 2">
            <span style="margin-left: 5px">客户姓名：{{currentUser.customer.name}}</span>
          </el-form-item>
          <el-form-item>
            <span style="color: red">*</span>
            <span style="margin-left: 5px">开始日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="beginDate"></el-date-picker>
            <span style="color: red;margin-left: 20px">*</span>
            <span style="margin-left: 5px">结束日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="endDate"></el-date-picker>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 1 && selectedCustomer === ''">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">选择提货人后展示发货详情</span>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 1 && selectedCustomer !== ''">
            <el-radio v-model="selectedStorage" v-for="sto in storageOrgInfo" :key="sto.id" :label="sto.id" style="margin-top: 10px;margin-bottom: 10px;min-width: 20vw">
                <span style="color: black">
<!--                  <span style="font-weight: bold">发货公司：</span>{{ sto.name }}-->
                  <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ sto.orgCompany.name }}
                </span>
            </el-radio>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 2">
            <el-radio v-model="selectedStorage" v-for="sto in storageOrgInfo" :key="sto.id" :label="sto.id" style="margin-top: 10px;margin-bottom: 10px;min-width: 20vw">
                <span style="color: black">
<!--                  <span style="font-weight: bold">发货公司：</span>{{ sto.name }}-->
                  <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ sto.orgCompany.name }}
                </span>
            </el-radio>
<!--            <el-radio>-->
<!--                <span style="color: black">-->
<!--                  <span style="font-weight: bold">发货公司：</span>{{ this.storageOrgDef.name }}-->
<!--                  <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ this.storageOrgDef.orgCompany.name }}-->
<!--                </span>-->
<!--            </el-radio>-->
          </el-form-item>
          <el-form-item class="submit">
            <el-button class="but" @click="queryPayHistory(1)" :loading="loading">提交查询信息</el-button>
          </el-form-item>
        </el-form>
      </el-main>
      <el-main class="list">
        <el-table :data="tableData" border size="mini" show-summary>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" :disabled="disabled" @click="repairPay(scope.$index, scope.row)" v-if="scope.row.easBillNumber === null || scope.row.easBillNumber === ''">通知商户</el-button>
              <el-button style="background: #f5f7fa" v-else size="small" disabled>通知商户</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column prop="companyName" label="付款公司"></el-table-column>
          <el-table-column prop="customerName" label="付款客户"></el-table-column>
          <el-table-column prop="accountMoney" label="付款金额"></el-table-column>
          <el-table-column label="是否到账">
            <template slot-scope="scope">
              <span v-if="scope.row.easBillNumber === null || scope.row.easBillNumber === ''" style="color:red">否</span>
              <span v-else>是</span>
            </template>
          </el-table-column>
          <el-table-column label="订单时间" prop="createTime"></el-table-column>
          <el-table-column label="操作人身份">
            <template slot-scope="scope">
              <span v-if="scope.row.payOperatorType === '2'">财务人员</span>
              <span v-if="scope.row.payOperatorType === '1'">业务员</span>
              <span v-if="scope.row.payOperatorType === '0'">客户</span>
            </template>
          </el-table-column>
          <el-table-column label="付款方式" prop="paySourceType"></el-table-column>
        </el-table>
      </el-main>
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-count="pageCount"
        :page-size="pageSize"
        :total="total"
        style="margin-top: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>

import {mapGetters} from "vuex";
import {queryPayHistory} from "../../../api/system/pay_history";
import {queryBySale} from "../../../api/system/org-storage";
import {queryCustomerListById} from "../../../api/system/person";
import {queryAbcPayStatus, queryPayRecordList, repairPay} from "../../../api/system/pay";

export default {
  data() {
    return {
      selectedCustomerId:'',
      operatorOption:[
        {type:0 , content:'全部'},
        {type:1 , content:'业务员'},
        {type:2 , content:'客户'},
        {type:3 , content:'财务人员'}
      ],
      selectedOperatorType:0,
      payStatusOption:[
        {type:0 , content:'全部'},
        {type:1 , content:'已生成收款单'},
        {type:2 , content:'支付未完成'}
      ],
      selectedPayStatus:0,
      payTypeOption:[
        {type:0 , content:'全部'},
        {type:1 , content:'农行直连支付'},
        {type:2 , content:'农行授权支付'}
      ],
      selectedPayType:0,
      saleOrgId:'',
      saleOrgName:'',
      selectedCustomer:'',
      selectedStorage:'',
      beginDate:this.getDay(-4),
      endDate:this.getDay(0),
      customerOption:[],
      loading:false,
      currentPage:1,
      pageSize:10,
      pageCount:1,
      total:0,
      storageOrgInfo:'',
      storageOrgDef:{
        id:'',
        name:'',
        orgCompany:{
          name:''
        }
      },//默认库存组织
      customerInfo:[],
      tableData:[],
      showClose:false,
      disabled:false
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    // ...mapGetters(["companyOrgs"]),
    // ...mapGetters(["index"])
  },
  mounted() {
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")

    this.queryUserInfo()
    this.queryOrgBySaleOrg()
  },
  methods: {
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    //改变页码触发
    pageChange(){
      this.queryPayHistory(this.currentPage)
    },
    queryUserInfo(){
      if(this.currentUser.userType === 1){
        this.personInfo = this.currentUser.person
        this.queryCustomer()
      }
      // else if(this.currentUser.userType === 2){
        // this.customerInfo = this.currentUser.customer
        // this.queryPersonListById(this.customerInfo.number)
        // this.queryCustomerLinkmanById(this.customerInfo.id)
      // }
    },
    queryOrgBySaleOrg(){
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if(res.code === 200){
          // console.log(res.data)
          this.storageOrgInfo = res.data
          for(let i = 0; i < this.storageOrgInfo.length; i++){
            if(this.storageOrgInfo[i].isDefault === 1){
              this.storageOrgDef = this.storageOrgInfo[i]
              break;
            }
          }
          this.selectedStorage = this.storageOrgDef.id
          // console.log('默认组织：'+this.storageOrgDef.id)

        }else{
          this.$modal.msgError("获取您的组织信息失败，请联系营业室进行维护");
        }
      });
    },
    queryCustomer(){
      let param = {};
      let saleOrgList = [{id:this.saleOrgId}]
      param.number = this.personInfo.number
      param.orgSaleList = saleOrgList
      // console.log(param)
      queryCustomerListById(param).then(res => {
        if(res.code === 200){
          this.customerList = res.data
          this.customerOption = res.data
        }else{
          this.$modal.msgError("获取您的组织信息失败，请联系营业室进行维护");
        }
      });
    },
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        this.showClose = false
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    cancelReadOnly(onOff) {
      if (onOff) { // 打开下拉框 显示可清空按钮
        this.showClose = true
      }
      this.$nextTick(() => {
        if (!onOff) {
          const {select} = this.$refs;
          const input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    //下拉框开启搜索功能
    dataFilter(val) {
      this.value = val;
      if (val) { //val存在
        this.customerOption = this.customerList.filter((item) => {
          if (!!~item.name.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase()) || !!~item.number.indexOf(val) || !!~item.number.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else { //val为空时，还原数组
        this.customerOption = this.customerList;
      }
    },
    getDay(day) {
      //Date()返回当日的日期和时间。
      let days = new Date();
      //getTime()返回 1970 年 1 月 1 日至今的毫秒数。
      let getTimes = days.getTime() + 1000 * 60 * 60 * 24 * day;
      //setTime()以毫秒设置 Date 对象。
      days.setTime(getTimes);
      let year = days.getFullYear();
      let month = days.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let today = days.getDate();
      if (today < 10) {
        today = "0" + today;
      }
      return year + "-" + month + "-" + today;
    },
    queryPayHistory(currentPage){
      let groupQuery = {current:this.currentPage , size:this.pageSize};
      //构建查询条件
      if(this.beginDate !== null && this.beginDate !== ''){
        groupQuery.startTime = this.beginDate + ' 00:00:00';
      }
      if(this.endDate !== null && this.endDate !== ''){
        groupQuery.endTime = this.endDate + ' 23:59:59';
      }
      if(this.currentUser.userType === 1){
        if(this.selectedCustomer === ''){
          this.$modal.msgWarning("请先选择客户");
          return
        }
        groupQuery.customerId = this.selectedCustomer;
        groupQuery.companyId = this.selectedStorage
      }else if(this.currentUser.userType === 2){
        groupQuery.customerId = this.currentUser.customer.id
        groupQuery.companyId = this.storageOrgDef.id
      }
      if(this.selectedOperatorType !== 0){
        groupQuery.operatorType = this.selectedOperatorType;
      }
      if(this.selectedPayStatus !== 0){
        groupQuery.payStatus = this.selectedPayStatus;
      }
      if(this.selectedPayType !== 0){
        groupQuery.queryPayType = this.selectedPayType;
      }

      groupQuery.current = currentPage;
      groupQuery.size = this.pageSize

      // console.log(groupQuery)
      this.loading = true
      queryPayRecordList(JSON.stringify(groupQuery)).then(res => {
        //console.log(res)
        if(res.code === 200){

          this.loading = false

          if(res.data.records.length === 0){
            this.tableData = []
            this.total = 0;
            this.currentPage = 1
            this.pageCount = 10
            this.pageSize = 10
            this.$modal.msg("查询不到您的付款记录");
            return
          }

          //console.log(res)
          this.tableData = res.data.records;

          this.total = res.data.records.total;
          this.currentPage = res.data.current
          this.pageCount = res.data.pages
          this.pageSize = res.data.size
        }
      }).catch(e =>{
        console.log(e);
        this.$modal.msgError("查询不到您的付款记录，请重试");
      })
    },
    repairPay(index, row){
      let payTypeId = ''
      if(row.payType === 'GATEWAY_PC_PAY' || row.payType === 'GATEWAY_PHONE_PAY' || row.payType === 'ABC_PHONE_PAY' || row.payType === 'ABC_PC_PAY'){
        repairPay({orderId:row.orderId,payTypeId:payTypeId}).then(res =>{
          // console.log(res)
          if(res.code === 200){
            this.$modal.msgSuccess("结算通知单生成成功，单据号："+res.data.easBillNumber);
            row.easBillNumber = res.data.easBillNumber
          }
        }).catch(e=>{
          console.log(e)
        })
      } else{
        this.$message.error("该支付类型不支持该操作！");
      }
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 85vh;
    margin-top: -10px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .con{
    margin-top: 10px;
    border: 1px solid rgb(196, 196, 196);
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_payHistory{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .submit{
    text-align: center;
  }
  .but{
    width: 160px;
    font-size: 16px;
    color: white;
    border: none;
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1.00) 0%,rgba(253,131,145,1.00) 100%);
    border-radius: 20px;
  }
  .list{
    margin-top: 30px;
    border: 1px solid rgb(196, 196, 196);
  }
</style>
